import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProjetoCadastro } from '../models/projeto-cadastro.model';
import { BaseService } from 'src/app/base/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class ProgramaService extends BaseService<ProjetoCadastro> {

  constructor(public http: HttpClient) {
    super(http);
  }
  
  public getPathModule(): string {
    return '/projetos/programa';
  }
  
  public getListSearchAgregadores(obj: any = null): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + '/search-agregadores', obj, { headers: this.headers });
  }
  
  public getListSearchProgramas(obj: any = null): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + '/search-projetos', obj, { headers: this.headers });
  }

  public listFilters(): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl + "/list-filters", { headers: this.headers });
  }

  // CONSULTA/PESQUISA PROJETO AGREGADOR
  public getListSearchProjetos(obj: any = null): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + '/search-programas', obj, { headers: this.headers });
  }

  public getById(id: number, filterProds: any = null): Observable<ProjetoCadastro> {
    return this.http.get<ProjetoCadastro>(this.baseUrl + '/' + id + '?filterProds=' + filterProds, { headers: this.headers });
  }

  public getList(id: number, filterProds: any = null): Observable<ProjetoCadastro> {
    return this.http.get<ProjetoCadastro>(this.baseUrl + '/list/' + id + '?filterProds=' + filterProds, { headers: this.headers });
  }



}
